import { render } from "./CaseForm.vue?vue&type=template&id=67efdfd1&ts=true"
import script from "./CaseForm.vue?vue&type=script&lang=ts"
export * from "./CaseForm.vue?vue&type=script&lang=ts"

import "./CaseForm.vue?vue&type=style&index=0&id=67efdfd1&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__